
export const createTagAction = (id, type) => {

    if (id == null) {
        throw new Error("Id must be set");
    }

    var tagAction = {
        id: id,
        type: type,
        tagName: null,
        tagTemplate: null,
        filter: null
    }

    if (tagAction.type === "add") {
        validateTagAction(tagAction);
        return tagAction;
    }

    if (tagAction.type === "conditionalAdd") {
        tagAction.tagTemplate = "";
        tagAction.filter = {
            value: null,
            operator: "EqualTo",
            field: "Name"
        };
        validateTagAction(tagAction);
        return tagAction;
    }

    if (tagAction.type === "changePrefix") {
        tagAction.newPrefix = "";
        tagAction.originalPrefix = "";
        tagAction.keepOriginalTags = false;
        validateTagAction(tagAction);
        return tagAction;
    }

    if (tagAction.type === "remove") {
        tagAction.filter = {
            value: null,
            operator: "EqualTo",
            field: "Name"
        };
        validateTagAction(tagAction);
        return tagAction;
    }

    if (tagAction.type === "rename") {
        tagAction.filter = {
            value: null,
            operator: "EqualTo",
            field: "Name"
        };
        validateTagAction(tagAction);
        return tagAction;
    }

    throw new Error("Unknown tag action type");
}

function containsSpecialCharacters(str) {
    var regex = /[=[\]'\\,<>?]/g;
    return regex.test(str);
}

export const validateTagAction = (tagAction) => {

    tagAction.error = null;

    if ((tagAction.type === "add") && (tagAction.tagName === null || tagAction.tagName === "")) {
        tagAction.error = "Tag name value must be specified";
        return;
    }

    if (tagAction.type === "changePrefix") {

        if (tagAction.newPrefix === null) {
            tagAction.error = "New prefix value must be specified";
        }

        if (tagAction.originalPrefix === null) {
            tagAction.error = "Original prefix value must be specified";
        }

        if (tagAction.keepOriginalTags === null) {
            tagAction.error = "KeepOriginalTags value must be specified";
        }

        return;
    }

    if ((tagAction.type === "conditionalAdd") && (tagAction.tagTemplate === null || tagAction.tagTemplate === "")) {
        tagAction.error = "New tag name must be specified";
        return;
    }

    if ((tagAction.type === "rename") && (tagAction.tagTemplate === null || tagAction.tagTemplate === "")) {
        tagAction.error = "Tag name value must be specified";
        return;
    }

    if ((tagAction.type === "add" || tagAction.type === "rename") && (containsSpecialCharacters(tagAction.tagTemplate))) {
        tagAction.error = "Tag contains characters that are not allowed";
        return;

    }

    if ((tagAction.type === "add") && (tagAction.tagName.length > 255)) {
        tagAction.error = "Tag can be up to 255 characters in lenght";
        return;

    }

    if ((tagAction.type === "conditionalAdd") && (tagAction.tagTemplate.length > 255)) {
        tagAction.error = "Tag can be up to 255 characters in lenght";
        return;
    }

    if (tagAction.type === "rename" && tagAction.tagTemplate.length > 255) {
        tagAction.error = "Tag can be up to 255 characters in lenght";
        return;

    }

    if (tagAction.filter != null) {
        if (tagAction.filter.value === null || tagAction.filter.value === "") {
            tagAction.error = "Condition tag value must be specified";
            return;

        }
    }
}